import React from 'react';

const NotFound = () => (
  <div style={{ textAlign: 'center', marginTop: '2rem' }}>
    <h1>404 – Page Not Found</h1>
    <p>Sorry, the page you’re looking for doesn’t exist.</p>
  </div>
);

export default NotFound;
